export default (params) => ({
  trigger: {
    name: 'product_type_section.select_alternative_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      method: {
        enum: [
          'image',
          'title',
        ],
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'product_type_section_alternative_overlay',
      },
    },
  },
});
